// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11.9999 1.9165L22.0999 6.12484L11.9999 10.3332L1.8999 6.12484L11.9999 1.9165ZM1.9999 9.9802L11.9999 14.2881L21.9999 9.9802V12.1611L11.9999 16.4657L1.9999 12.1611L1.9999 9.9802ZM1.9999 15.9802L11.9999 20.2881L21.9999 15.9802V18.1611L11.9999 22.4657L1.9999 18.1611L1.9999 15.9802Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-layers-filled')
export default class LayersFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'layers-filled',
    }
  }
}
